import { getCCTV, putCCTV, postCCTV } from '../../../../api/eastCoastDataApi/device/VideoCameraApi'
import CONST from '../../../../utils/const'
import Utils from '../../../../utils/utils'

const state = {
  allCCTV: [],
  cctvData: []
}

const getters = {
  getAllCCTV: state => {
    return state.allCCTV
  },
  getCCTVData: state => {
    return state.cctvData
  },
  getCCTVById: state => (id) =>{
    return state.allCCTV.filter(cctv => id === cctv.id)
  },
  getVehicleCCTVData: state => {
    return state.allCCTV.filter(cctv => { 
      return cctv.videoPurposeType === CONST.VIDEO_PURPOSE_TYPE.VEHICLE_IN || cctv.videoPurposeType === CONST.VIDEO_PURPOSE_TYPE.VEHICLE_OUT
    })
  },
  getToiletPersonFlowCCTVData: state => {
    return state.allCCTV.filter(cctv => {
      return cctv.videoPurposeType === CONST.VIDEO_PURPOSE_TYPE.TOILET_PERSON_FLOW
    })
  }
}

const actions = {
  async getCCTV({ commit }, condition) {
    commit('CCTV', await getCCTV(condition))
  },

  async postCCTV({ commit }, cctv) {
    const result = await postCCTV(cctv)
    if (result.success) {
      commit('updateDevice', { cctv, mode: 'post' })
    }
    return result
  },

  async putCCTV({ commit }, cctv) {
    const result = await putCCTV(cctv)
    if (result.success) {
      commit('updateCCTV', { cctv, mode: 'put' })
    }
    return result
  },
}

const mutations = {
  CCTV(state, data) {
    if (Utils.isEmptyObject(data)) {
      return
    }

    state.allCCTV = data
    state.cctvData = data
  },

  updateCCTV(state, { data, mode }) {
    switch (mode) {
      case 'post':
        state.allCCTV.push(data)
        break
      
      case 'put':
        let targetIndex  = state.allCCTV.findIndex(d => d.id === data.id)
        if (targetIndex !== -1) {
          state.allCCTV[targetIndex] = data;
        } 
        break
  
      case 'delete' :
        state.allCCTV = state.allCCTV.filter(d => d.id !== data)
        break    
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}